<template>
  <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card title="Master Device Value">
      <!-- <b-card-text>Device.</b-card-text> -->
      <validation-observer ref="simpleRules">
        <b-form @submit.prevent>
          <b-row>
            <!-- Device Value -->
            <b-col cols="12">
              <b-form-group label="Device Value" label-for="v-Device Value">
                <validation-provider #default="{ errors }"  name="Device Value" rules="required">
                  <v-select id="v-Device Value" v-model="form.select_1" placeholder="Chose  Device Value" autocomplete="off" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="title" :options="DeviceValueOptions" :reduce="DeviceValueOptions => DeviceValueOptions.value"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Key -->
            <b-col cols="12">
              <b-form-group label="Key" label-for="v-Key">
                <validation-provider #default="{ errors }"  name="Key" rules="required">
                  <b-form-input  id="v-Key" :state="errors.length > 0 ? false:null" v-model="form.text_1" placeholder="Key" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- Value -->
            <b-col cols="12">
              <b-form-group label="Value" label-for="v-Value">
                <validation-provider #default="{ errors }"  name="Value" rules="required">
                  <b-form-input  id="v-Value" :state="errors.length > 0 ? false:null" v-model="form.text_2" placeholder="Value" />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- submit and reset -->
            <b-col cols="12"><div class="h-50 d-inline-block"></div></b-col>
            <b-col cols="12">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click.prevent="validationForm"> Submit </b-button>
              <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary"> Reset </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      </b-card>
  </b-overlay>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { BRow, BOverlay, BFormTextarea, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BCol, BFormGroup, BFormCheckbox,  BFormInput, BForm, BButton, BCard,  BImg} from 'bootstrap-vue'
import { mapState } from 'vuex'
import { required } from '@validations'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
export default {
  components: { vSelect, BOverlay, BFormTextarea, BCardText, BFormFile, BMediaBody, BMedia, BMediaAside, BLink, BFormCheckbox,  ValidationProvider, ValidationObserver, BCard, BImg, BRow, BCol, BFormGroup, BFormInput, BForm, BButton },
  directives: { Ripple },
  data () {
    return { 
      form: {id: null, select_1: '', text_1: '',text_2: ''},
      show: false,
      required 
    }
  },
  computed: {
    ...mapState({ DeviceValueOptions: state => state.device.value.options })
  },
  created () {
    this.$store.dispatch('device/getAllValue')
  },
  methods: {
    validationForm () {
      this.show = true
      this.$refs.simpleRules.validate()
      .then(success => {
        if (success) {
          const formData = this.form 
			    this.$store.dispatch('device/formPostPutKey', formData)
          .then(res => {
            this.notification('Success','CheckIcon','success','You have successfully')
          }, 
          err => {
            this.show = false
            this.notification('Failed','CloseIcon','danger','You have unsuccessful')
          })
        } else {
          this.show = false
          this.notification('Failed','CloseIcon','danger','You have unsuccessful')
        }
      })
    },
    notification (a,b,c,d) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: { title: a, icon: b, variant: c, text: d}
      })
    },
    getData (id) {
			this.$store.dispatch('device/getByIdKey', id).then(data => {
        this.form.id = data.id
        this.form.select_1 = data.device_value_id
        this.form.text_1 = data.key
        this.form.text_2 = data.value
        this.show = false
      })
    }
  },
  mounted () {
    if (this.$route.params.id) {
      this.show = true
      this.getData(this.$route.params.id)
    }
  }
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>